'use client';

import { c as _c } from "react/compiler-runtime";
import { LocalizedLink } from '../LocalizedLink/LocalizedLink';
import { imageCardDefaults } from './ImageCard.defaults';
import { type ImageCardProps } from './ImageCard.props';
export const ImageCard = t0 => {
  const $ = _c(24);
  const props = t0 === undefined ? imageCardDefaults : t0;
  const {
    heading,
    subheading,
    imageSrc,
    redirectUrl,
    headingColor,
    subheadingColor,
    showGradient
  } = props;
  const Wrapper = redirectUrl ? LocalizedLink : "div";
  const t1 = `${showGradient ? "linear-gradient(180deg, rgba(0,0,0,0) 52.41%, #000000 100%), " : ""}url(${imageSrc})`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      backgroundImage: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = redirectUrl ?? "";
  let t4;
  if ($[2] !== headingColor) {
    t4 = {
      color: headingColor
    };
    $[2] = headingColor;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = heading ?? "";
  let t6;
  if ($[4] !== t5) {
    t6 = {
      __html: t5
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t6) {
    t7 = <h6 className="text-heading-display-3 mb-1" style={t4} dangerouslySetInnerHTML={t6} />;
    $[6] = t4;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== subheadingColor) {
    t8 = {
      color: subheadingColor
    };
    $[9] = subheadingColor;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = subheading ?? "";
  let t10;
  if ($[11] !== t9) {
    t10 = {
      __html: t9
    };
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t8) {
    t11 = <p className="text-body-md" style={t8} dangerouslySetInnerHTML={t10} />;
    $[13] = t10;
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t7) {
    t12 = <div className="mt-auto">{t7}{t11}</div>;
    $[16] = t11;
    $[17] = t7;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== Wrapper || $[20] !== t12 || $[21] !== t2 || $[22] !== t3) {
    t13 = <Wrapper className="flex h-[490px] flex-col rounded-[32px] bg-cover bg-center bg-no-repeat px-4 py-8 lg:h-[700px] lg:p-16" style={t2} href={t3}>{t12}</Wrapper>;
    $[19] = Wrapper;
    $[20] = t12;
    $[21] = t2;
    $[22] = t3;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};